import React, { useState } from "react";

type PromptModalProps = {
  prompt:  any;
//   onClose: () => void;
};

const PromptModal: React.FC<PromptModalProps> = ({ prompt}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (text: string | object) => {
    const content =
      typeof text === "string" ? text : JSON.stringify(text, null, 2);
    navigator.clipboard.writeText(content);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (!prompt){
    prompt = {}
  }

  return (
    <div className="relative mb-4">
      <button
        onClick={() => handleCopy(prompt)}
        className={`absolute top-2 right-4 text-xs px-3 py-1 bg-white/20 hover:bg-white/30 text-yellow-200 rounded transition-all border border-white/10 ${
          copied ? "text-green-300" : ""
        }`}
      >
        {copied ? "✅ Copied!" : "Copy"}
      </button>

      <pre className="bg-black/20 border border-white/10 text-sm p-3 rounded max-h-64 overflow-y-auto text-yellow-100 whitespace-pre-wrap font-mono">
        {typeof prompt === "string" ? prompt : JSON.stringify(prompt, null, 2)}
      </pre>
    </div>
  );
};

export default PromptModal;
